export interface EventData {
  id: string;
  name: string;
  description: string;
  price: string;
  totalTickets: string;
  contractAddress: string;
  createdAt: string;
  creator: string;
}

export const initSampleEvents = () => {
  // Check if we're in browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  const sampleEvents: Omit<EventData, 'id' | 'createdAt'>[] = [
    {
      name: "Concert Rock Festival 2024",
      description: "Lễ hội âm nhạc rock lớn nhất năm với sự tham gia của các ban nhạc nổi tiếng. Trải nghiệm âm nhạc tuyệt vời với công nghệ âm thanh hiện đại.",
      price: "0.05",
      totalTickets: "500",
      contractAddress: "0x4bae21ae4ea46607d4fe34a20bf60c4d26aca092",
      creator: "0x742d35Cc6634C0532925a3b8D4C9db96C4b4d8b6"
    },
    {
      name: "Tech Conference Blockchain",
      description: "Hội nghị công nghệ blockchain với các chuyên gia hàng đầu thế giới. Cơ hội networking và học hỏi về công nghệ mới nhất.",
      price: "0.1",
      totalTickets: "200",
      contractAddress: "0x4bae21ae4ea46607d4fe34a20bf60c4d26aca092",
      creator: "0x8ba1f109551bD432803012645Hac136c772c3e3"
    },
    {
      name: "Art Exhibition NFT",
      description: "Triển lãm nghệ thuật NFT với các tác phẩm độc đáo từ các nghệ sĩ nổi tiếng. Khám phá thế giới nghệ thuật số.",
      price: "0.03",
      totalTickets: "300",
      contractAddress: "0x4bae21ae4ea46607d4fe34a20bf60c4d26aca092",
      creator: "0x1234567890123456789012345678901234567890"
    },
    {
      name: "Sports Championship Final",
      description: "Trận chung kết giải đấu thể thao lớn nhất năm. Chứng kiến những khoảnh khắc lịch sử của thể thao.",
      price: "0.08",
      totalTickets: "1000",
      contractAddress: "0x4bae21ae4ea46607d4fe34a20bf60c4d26aca092",
      creator: "0xabcdef1234567890abcdef1234567890abcdef12"
    },
    {
      name: "Gaming Tournament",
      description: "Giải đấu game online với tổng giải thưởng lớn. Tham gia và thể hiện kỹ năng gaming của bạn.",
      price: "0.02",
      totalTickets: "800",
      contractAddress: "0x4bae21ae4ea46607d4fe34a20bf60c4d26aca092",
      creator: "0x9876543210987654321098765432109876543210"
    }
  ];

  // Tạo events với id và timestamp
  const eventsWithId: EventData[] = sampleEvents.map((event, index) => ({
    ...event,
    id: `sample_${Date.now()}_${index}`,
    createdAt: new Date(Date.now() - (index * 24 * 60 * 60 * 1000)).toISOString(), // Tạo trong 5 ngày qua
  }));

  // Lưu vào localStorage
  try {
    const existingEvents = localStorage.getItem('xoso_events');
    let allEvents: EventData[] = [];
    
    if (existingEvents) {
      allEvents = JSON.parse(existingEvents);
    }
    
    // Kiểm tra xem đã có sample events chưa
    const hasSampleEvents = allEvents.some(event => event.id.startsWith('sample_'));
    
    if (!hasSampleEvents) {
      const updatedEvents = [...eventsWithId, ...allEvents];
      localStorage.setItem('xoso_events', JSON.stringify(updatedEvents));
      console.log('Sample events initialized successfully');
      return true;
    } else {
      console.log('Sample events already exist');
      return false;
    }
  } catch (error) {
    console.error('Error initializing sample events:', error);
    return false;
  }
};

export const clearSampleEvents = () => {
  // Check if we're in browser environment
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    const existingEvents = localStorage.getItem('xoso_events');
    if (existingEvents) {
      const allEvents: EventData[] = JSON.parse(existingEvents);
      const filteredEvents = allEvents.filter(event => !event.id.startsWith('sample_'));
      localStorage.setItem('xoso_events', JSON.stringify(filteredEvents));
      console.log('Sample events cleared successfully');
      return true;
    }
  } catch (error) {
    console.error('Error clearing sample events:', error);
    return false;
  }
  return false;
}; 